import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import {
  EdNotifyTemplateDict,
  ed2templates,
  templates2ed,
} from "./EdNotifyTemplate";
import { zNotifyTemplate } from "./ZNotifyTemplate";

export const loadNotifyTemplates = async (
  objectId: ZUid,
): Promise<EdNotifyTemplateDict> => {
  if (Number(objectId) < 0) return {};
  const resp = await rest.get(apiObjUrl("/message-template"), {
    params: { objectId },
  });
  const list = zNotifyTemplate.array().parse(resp.data);
  return templates2ed(list);
};

export const saveNotifyTemplates = async (
  objectId: ZUid,
  dict: EdNotifyTemplateDict,
): Promise<void> => {
  const list = ed2templates(dict);
  await rest.post(apiObjUrl("/message-template"), list, {
    params: { objectId },
  });
};
